module.exports = __webpack_public_path__ + "static/media/1_en.9da1abd0.png";